module.exports = __webpack_public_path__ + "static/13-f72f6a6c804288bf367c07d1fc19c8e4.jpg";